import { Button, Col, DatePicker, Form, Input, Row, Space, Table, Tabs, Upload, UploadFile, UploadProps } from 'antd';
import { ChungChi } from '../../models/nhanvien/ChungChi';
import { dateCommon, validateMessages } from '../../helpers/common';
import { DeleteOutlined, EditOutlined, PlusOutlined, SaveOutlined, UploadOutlined, EyeOutlined } from '@ant-design/icons';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { luuChungChi, xoaChungChi } from '../../services/nhanvien';
import { toast } from 'react-toastify';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import dayjs from 'dayjs';
import { urlAdmin } from '../../constants';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';

const ChungChiBox = ({ listData, idNhanVien, isThemMoi, onSubmit }: { listData?: Array<ChungChi>, idNhanVien?: number, isThemMoi?: boolean, onSubmit: () => void }) => {
    var dataSource = (listData || []).map((item: any, index) => { item.key = index; return item; });

    const [loading, setLoading] = useState(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);

    const [selectedCC, setSelectedCC] = useState<ChungChi>(new ChungChi);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    useEffect(() => {
        var fileHienTai: any = (selectedCC?.dsTaiLieu || []).map((item: TaiLieu) => {
            return {
                uid: item.idTaiLieu + "tailieu",
                name: item.tenTep,
                status: 'done',
                url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
                //url: item.duongDan.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
            };
        });
        setFileList(fileHienTai)
    }, [selectedCC]);

    const props: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoa([...idsTaiLieuXoa, id]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };

    const [form] = Form.useForm();
    const setFormDetailModal = (value: ChungChi | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "idNhanVien": idNhanVien,
            "ngayCapChungChi": value?.ngayCapChungChi ? dayjs(dateCommon.formatDate(value?.ngayCapChungChi), "DD/MM/YYYY") : null,
            "tenChungChi": value?.tenChungChi || "",
            "loaiChungChi": value?.loaiChungChi || "",
            "donViCap": value?.donViCap || "",
            "xepLoai": value?.xepLoai || "",
            "apDungTuNgay": value?.apDungTuNgay ? dayjs(dateCommon.formatDate(value?.apDungTuNgay), "DD/MM/YYYY") : null,
            "apDungDenNgay": value?.apDungDenNgay ? dayjs(dateCommon.formatDate(value?.apDungDenNgay), "DD/MM/YYYY") : null,
        });
        setShowModalChiTiet(true);
    }

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            await luuChungChi(values, fileList, idsTaiLieuXoa);
            setSelectedCC(new ChungChi);
            setShowModalChiTiet(false);
            toast.success('Lưu thông tin chứng chỉ thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        setLoading(false);
        onSubmit();
    };

    const onDelete = async () => {
        try {
            setLoading(true);
            await xoaChungChi(idXoa);
            toast.success('Xoá thông tin chứng chỉ thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setLoading(false);
        onSubmit();
    }

    return (
        <div className="card-outline">
            {idXoa > 0 && <ModalTextForm show={idXoa > 0}
                title="Xoá thông tin chứng chỉ"
                handleClose={() => setIdXoa(0)}
                handleSave={onDelete}>
                Xác nhận xóa thông tin chứng chỉ đang chọn
            </ModalTextForm>}
            {showModalChiTiet && <ModalTextForm title="Quản lý thông tin chứng chỉ"
                hideFooter
                show={showModalChiTiet}
                handleClose={() => { setShowModalChiTiet(false); setSelectedCC(new ChungChi); } }
            >
                {isThemMoi ?
                    <Form
                        layout="vertical"
                        validateMessages={validateMessages}
                        onFinish={onFinish}
                        form={form}
                    >
                        <Form.Item hidden name="id"><Input /></Form.Item>
                        <Form.Item hidden name="idNhanVien"><Input /></Form.Item>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Áp dụng từ ngày"
                                    name="apDungTuNgay"
                                    rules={[{ required: true }]}
                                >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Chọn ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Áp dụng đến ngày"
                                    name="apDungDenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Chọn ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Ngày cấp chứng chỉ"
                                    name="ngayCapChungChi"
                                    rules={[{ required: true }]}
                                >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="Ngày quyết định" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Đơn vị cấp"
                                    name="donViCap"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item
                            label="Tên chứng chỉ"
                            name="tenChungChi"
                            rules={[{ required: true }]} >
                            <Input />
                        </Form.Item>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Loại chứng chỉ"
                                    name="loaiChungChi"
                                    rules={[{ required: true }]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Xếp loại"
                                    name="xepLoai" >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <Upload {...props}>
                                    <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                                </Upload>
                            </Col>
                        </Row>
                        <Form.Item>
                            <Button type="primary" className="float-right mt-2" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                                Lưu
                            </Button>
                        </Form.Item>
                    </Form>
                    :
                    <>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Áp dụng từ ngày</div>
                                    <label>{selectedCC?.apDungTuNgay != null ? dateCommon.formatDate(selectedCC?.apDungTuNgay) : ""}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Áp dụng đến ngày</div>
                                    <label>{selectedCC?.apDungDenNgay != null ? dateCommon.formatDate(selectedCC?.apDungDenNgay) : ""}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Ngày cấp chứng chỉ</div>
                                    <label>{selectedCC?.ngayCapChungChi != null ? dateCommon.formatDate(selectedCC?.ngayCapChungChi) : ""}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Đơn vị cấp</div>
                                    <label>{selectedCC?.donViCap}</label>
                                </div>
                            </Col>
                        </Row>
                        <Form.Item
                            label="Tên chứng chỉ"
                            name="tenChungChi" >
                            {selectedCC?.tenChungChi}
                        </Form.Item>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Loại chứng chỉ</div>
                                    <label>{selectedCC?.loaiChungChi}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Xếp loại</div>
                                    <label>{selectedCC?.loaiChungChi}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <div className="mb-1">
                                    <div>File đính kèm</div>
                                    <Upload {...props} disabled={true}>
                                    </Upload>
                                </div>
                            </Col>
                        </Row>
                    </>}
            </ModalTextForm>}
            <Tabs tabBarExtraContent={isThemMoi ?
                <Button
                    className="hrm-btn hrm-btn-warning"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
                : null} defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Chứng chỉ',
                        children:
                            <div className="card">
                                <Table
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={dataSource}
                                    pagination={false}
                                    rowClassName={(record, index) => {
                                        return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                    }}
                                >
                                    <Column
                                        title="STT"
                                        key="STT"
                                        render={(value, record, index) =>
                                        (
                                            <>
                                                {index + 1}
                                            </>
                                        )
                                        }
                                    />
                                    <Column title="Tên chứng chỉ" dataIndex="tenChungChi" key="tenChungChi" />
                                    <Column title="Loại chứng chỉ" dataIndex="loaiChungChi" key="loaiChungChi" />
                                    <Column
                                        title="Ngày cấp"
                                        key="ngayCapChungChi"
                                        render={(value: ChungChi, record, index) =>
                                        (
                                            <>
                                                {dateCommon.formatDate(value?.ngayCapChungChi)}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title="Thời hạn"
                                        key="thoiHan"
                                        render={(value: ChungChi, record, index) =>
                                        (
                                            <>
                                                {value?.apDungDenNgay != null ? dateCommon.formatDate(value?.apDungTuNgay) + " - " + dateCommon.formatDate(value?.apDungDenNgay) :
                                                    `Từ ${dateCommon.formatDate(value?.apDungTuNgay)}`}
                                            </>
                                        )
                                        }
                                    />
                                    {isThemMoi ?
                                        <Column width="10%" title="" key="action"
                                            render={(value: ChungChi, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                        icon=<EditOutlined rev="" />
                                                        onClick={() => { setFormDetailModal(value); setSelectedCC(value) }}
                                                    >
                                                        Sửa
                                                    </Button>
                                                    <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                        onClick={() => { setIdXoa(value.id) }}
                                                        icon=<DeleteOutlined rev="" />
                                                    >
                                                        Xóa
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        /> :
                                        <Column width="10%" title="" key="action"
                                            render={(value: ChungChi, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Xem"
                                                        icon=<EyeOutlined rev="" />
                                                        onClick={() => { setFormDetailModal(value); setSelectedCC(value) }}
                                                    >
                                                        Xem
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        />
                                    }
                                </Table>
                            </div>
                    },
                ]}>
            </Tabs>
        </div>
    );
};

export default ChungChiBox;
